import { SubmitModel } from '../../../../../shared/kiosk';
import { AbstractElementEditor } from './AbstractElementEditor';

export class SubmitEditor extends AbstractElementEditor<SubmitModel> {
  public getDescription(): string {
    return 'Submit button';
  }

  public getName(): string {
    return 'Submit button';
  }

  public getIcon(): string {
    return 'check_circle';
  }
}
